import classNames from "classnames"
import createReactClass from "create-react-class"
import { get } from "lodash"
import PropTypes from "prop-types"
import React from "react"

import Html from "./html.jsx"
import styles from "./table-header.less"

const isElementParent = (element, parent) => {
  let isParent = element.parentElement === parent

  while (!isParent && element.parentElement) {
    element = element.parentElement
    isParent = element.parentElement === parent
  }

  return isParent
}

export default createReactClass({
  displayName: "TableHeader",
  propTypes: {
    className: PropTypes.string,
    showInDialog: PropTypes.bool,
    isDialogHidden: PropTypes.bool,
    onHeaderFixed: PropTypes.func,
  },
  getInitialState() {
    return {
      columnsWidth: [],
      displayFixed: false,
    }
  },
  getHeaderChildren(fixed) {
    return React.Children.toArray(this.props.children)
      .filter(React.isValidElement)
      .map((item) => {
        return React.cloneElement(item, {
          setHeaderScrollPosition: this.setHeaderScrollPosition,
          setHeaderColumnsWidth: this.setHeaderColumnsWidth,
          displayFixed: fixed ? this.state.displayFixed : true,
          columnsWidth: this.state.columnsWidth,
          fixedHeaderNode: get(this, "_fixedHeader._element"),
          position: this.state.position,
          fixed,
        })
      })
  },
  componentDidMount() {
    if (!this.props.showInDialog) {
      window.addEventListener("scroll", this.handleDisplay)
      window.addEventListener("tab:show", this.handleDisplay)
      return
    }

    window.addEventListener("ps-scroll-y", this.handleScrollDialog)
  },
  componentWillUnmount() {
    if (!this.props.showInDialog) {
      window.removeEventListener("scroll", this.handleDisplay)
      window.removeEventListener("tab:show", this.handleDisplay)
      return
    }

    window.removeEventListener("ps-scroll-y", this.handleScrollDialog)
  },
  handleDisplay() {
    const headerElement = get(this, "_header._element")

    if (headerElement == null) {
      return
    }

    const { top } = headerElement.getBoundingClientRect()
    const displayFixed = top == 0 ? false : top - 15 < 0

    if (displayFixed !== this.state.displayFixed) {
      if (displayFixed) {
        this.setHeaderColumnsWidth(get(this, "_header._element"))
      }

      this.setState({ displayFixed })
      if (this.props.onHeaderFixed)
        this.props.onHeaderFixed(
          displayFixed,
          displayFixed ? get(this, "_fixedHeader._element") : get(this, "_header._element"),
        )
    }
  },

  handleScrollDialog(e) {
    const headerElement = get(this, "_header._element")

    if (headerElement == null) {
      return
    }

    if (!isElementParent(this._header._element, e.target)) {
      return
    }

    const tableTop = headerElement.getBoundingClientRect().top
    const dialogTop = e.target.getBoundingClientRect().top
    const top = tableTop - dialogTop
    const displayFixed = top - 15 < 0

    if (displayFixed !== this.state.displayFixed) {
      const _this = this

      setTimeout(() => {
        _this.setState({ displayFixed })
        if (_this.props.onHeaderFixed)
          _this.props.onHeaderFixed(
            displayFixed,
            displayFixed ? get(_this, "_fixedHeader._element") : get(_this, "_header._element"),
          )
        if (displayFixed) _this.setState({ fixedHeaderTop: dialogTop })
      }, 10)
    }
  },

  setHeaderColumnsWidth(header) {
    const columnsWidth = _.map(header.children, (c) => c.offsetWidth)

    if (!_.isEqual(this.state.columnsWidth, columnsWidth)) {
      this.setState({ columnsWidth })
    }
  },
  setHeaderScrollPosition(position) {
    if (!_.isEqual(this.state.position, position)) {
      this.setState({ position })
    }
  },
  render() {
    const className = classNames(styles.thead, this.props.className, "rs_skip")
    const fixedHeaderClassName = classNames(
      styles.thead,
      styles.fixedHeader,
      this.props.className,
      "rs_skip",
    )

    return (
      <Html
        type={this.props.htmlType}
        ref={(header) => (this._header = header)}
        className={className}
        role="rowgroup">
        {this.getHeaderChildren()}
        {/*<Html*/}
        {/*  type={this.props.htmlType}*/}
        {/*  ref={(fixedHeader) => (this._fixedHeader = fixedHeader)}*/}
        {/*  className={fixedHeaderClassName}*/}
        {/*  style={this.props.showInDialog ? { top: this.state.fixedHeaderTop } : null}*/}
        {/*  tabIndex={this.props.tabIndex}*/}
        {/*  ariaLabel={this.props.ariaLabel}>*/}
        {/*  {this.getHeaderChildren(true)}*/}
        {/*</Html>*/}
      </Html>
    )
  },
})
